import { selectClass } from "./schedulingControlStyles";

export default function ResourceCapacitySettings({ resources, disabled, onSave, compact = false }) {
  return <section className={`w-full max-w-md space-y-3 ${compact ? "" : "rounded-lg border border-slate-200 bg-white p-4"}`}>
    <h3 className="text-base font-semibold">Booking capacity</h3>
    <p className="text-xs text-slate-500">Choose whether this resource accepts one booking at a time or multiple bookings. Working hours still apply.</p>
    {resources.map(resource => <label key={resource.id} className="block text-xs font-medium text-slate-600">
      <span className="sr-only">{resource.name}</span>
      <select className={`${selectClass} w-full`} aria-label={`Booking capacity for ${resource.name}`} disabled={disabled}
        value={resource.maxConcurrentBookings === null ? "unrestricted" : "single"}
        onChange={e => onSave(resource, e.target.value === "unrestricted" ? null : 1)}>
        <option value="single">One booking at a time</option>
        <option value="unrestricted">Multiple bookings allowed</option>
      </select>
    </label>)}
  </section>;
}
